import { useNavigate } from 'react-router-dom';
import { TFormDataBulkDiscount } from '../formSchema';
import { useAppDispatch } from '../../../../../storeHook';
import { showAlert } from '../../../../../services/alert';
import {
  useAddBulkDiscountMutation,
  useEditBulkDiscountMutation,
} from '../../../../../services/discounts';
import { TBulkDiscount } from '../../../../../utils/types';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

export const useOnSubmitDiscountData = (
  fetchedData: TBulkDiscount | undefined
) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [
    updateBulkDetails,
    { isLoading: isUpdateDiscountLoading },
  ] = useEditBulkDiscountMutation();
  const [
    addBulkDiscount,
    { isLoading: isAddDiscountLoading },
  ] = useAddBulkDiscountMutation();

  const onEditDiscount = (
    values: TFormDataBulkDiscount
  ) => {
    // this.spinner.showSpinner.emit(true);
    const fromToday = dayjs(values.startDate).isSame(
      dayjs().startOf('day')
    );
    fetchedData &&
      updateBulkDetails({
        ...fetchedData,
        productName: values.productName,
        werks: values.werks,
        enterpriseId: values.enterpriseId,
        slabs: values.slabs,
        startDateStr:
          fetchedData.startDateStr ===
          dayjs(values.startDate).format('YYYY-MM-DD')
            ? dayjs(fetchedData.startDate).format(
                'YYYY-MM-DD  HH:mm'
              )
            : fromToday
            ? dayjs().format('YYYY-MM-DD HH:mm')
            : dayjs(values.startDate).format(
                'YYYY-MM-DD HH:mm'
              ),
        endDateStr:
          fetchedData.endDateStr ===
          dayjs(values.endDate).format('YYYY-MM-DD')
            ? dayjs(fetchedData.endDate).format(
                'YYYY-MM-DD HH:mm'
              )
            : dayjs(values.endDate)
                .endOf('day')
                .format('YYYY-MM-DD HH:mm'),
      })
        .unwrap()
        .then(() => {
          dispatch(
            showAlert({
              content:
                'discount details updated successfully',
            })
          );
          navigate('/discounts#bulk-discounts');
        })
        .catch((err) => {
          console.log(
            'update discounts err',
            err?.data?.title
          );
          // this.utility.handleError(err)
        });
  };

  const onAddDiscount = (values: TFormDataBulkDiscount) => {
    // this.spinner.showSpinner.emit(true);
    const fromToday = dayjs(values.startDate).isSame(
      dayjs().startOf('day')
    );
    addBulkDiscount({
      productName: values.productName,
      werks: values.werks,
      enterpriseId: values.enterpriseId,
      slabs: values.slabs,
      startDateStr: fromToday
        ? dayjs().format('YYYY-MM-DD HH:mm')
        : dayjs(values.startDate).format(
            'YYYY-MM-DD HH:mm'
          ),
      endDateStr: dayjs(values.endDate)
        .endOf('day')
        .format('YYYY-MM-DD HH:mm'),
    })
      .unwrap()
      .then(() => {
        dispatch(
          showAlert({
            content: 'discount details added successfully',
          })
        );
        navigate('/discounts#bulk-discounts');
      })
      .catch((err) => {
        console.log('add discounts err', err?.data?.title);
        // this.utility.handleError(err)
      });
  };

  return {
    onEditDiscount,
    isAddOrUpdateDiscountLoading:
      isUpdateDiscountLoading || isAddDiscountLoading,
    onAddDiscount,
  };
};
